import React from "react";

import './contact.css';
import { Button } from "react-bootstrap";

function Contact() {
    return (
        <>
            <div className="utama my-5">
                <h2 className="d-flex justify-content-center">Contact Us</h2>
                <div className="contact1">
                    <div className="kotak">
                        <h3 id="infor">Operational Hours 
                        <i class="bi bi-clock-fill lambang"></i>
                        </h3>
                        <div className="d-flex justify-content-center">
                            <div className="media
                            px-5">
                                <h5>Senin - Sabtu | Monday - Saturday: 09:00 - 17:00 (Local Time in Jakarta)</h5>
                                <h5>Minggu & Tanggal Merah | Sunday & Public Holidays: Closed</h5>
                            </div>
                        </div>
                    </div>
                    <div className="kotak">
                        <h3 id="infor">Reach Us 
                        <i class="bi bi-whatsapp lambang"></i>
                        </h3>
                        <div className="d-flex justify-content-center">
                            <div className="media
                            px-5">
                                <h5><i class="bi bi-whatsapp" style={{ marginRight: '6px' }}></i>Whatsapp / Call : 081290960101</h5><Button href="https://wa.me/+6281290960101" style={{ marginTop: '10px', backgroundColor: '#57EA6E', border: '0' }}>WhatsApp Link</Button>
                                <h5><i class="bi bi-envelope" style={{ marginRight: '6px' }}></i>Email: asco.motor@gmail.com</h5>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
};

export default Contact;